import { loggerScope } from '../../_common/client/logger';

enum LazyImageState {
    INITIAL,
    LOADING,
    LOADED,
}

const log = loggerScope.scope('lazy-image');

class LazyImage {
    private _state = LazyImageState.INITIAL;
    private readonly uri: string;
    private readonly imgElement: HTMLImageElement;

    constructor(imgElement: HTMLImageElement, uri: string) {
        this.uri = uri;
        this.imgElement = imgElement;
    }

    public get state() {
        return this._state;
    }

    public async load() {
        if (this.state != LazyImageState.INITIAL) return;
        this._state = LazyImageState.LOADING;
        const blob = await this.getImageBlob();
        if (!blob) return;
        const newUrl = URL.createObjectURL(blob);
        this.setImageSrc(newUrl);
        this._state = LazyImageState.LOADED;
    }

    public reset() {
        this._state = LazyImageState.INITIAL;
    }

    private async getImageBlob(): Promise<Blob | null> {
        const res = await fetch(this.uri);
        if (!res.ok) {
            log.warn('Failed to load image from', this.uri, 'Status', res.status);
            return null;
        }

        const mimeType = res.headers.get('Content-Type');
        if (!mimeType?.startsWith('image/')) {
            log.warn('Image at', this.uri, 'had invalid MIME type', mimeType, 'ignoring.');
            return null;
        }

        return await res.blob();
    }

    private setImageSrc(uri: string) {
        this.imgElement.setAttribute('src', uri);
        this.imgElement.removeAttribute('srcset');
    }
}

export default LazyImage;
